import { EcommerceProductApi } from '@/types/Product';
import { Engine } from '@/engine/core/Engine';

export function useProduct() {
    const productStore = useProductStore();
    const sceneStore = useSceneStore();
    const stageStore = useStageStore();
    const siteStore = useSiteStore();

    function processProductData(data: Ref<EcommerceProductApi | null>) {
        if (!data.value?.product) {
            return;
        }
        const productData = data.value.product;
        productStore.setProduct(productData);

        // Initialiser Engine de manière sûre
        try {
            const engine = Engine.getInstance();
            if (engine && engine.historic) {
                engine.historic.getMetadata = productStore.getMetadata;
            }
        } catch (error) {
            console.warn('Engine not yet initialized in processProductData:', error);
        }

        stageStore.selectCategory(productData.categoryId);

        const lightList = productData.lightList.map((light) => light.object);
        sceneStore.setLights(lightList);
        sceneStore.setCameraSettings(productData.settingsCamera);
    }

    function processEcommerceData(data: Ref<EcommerceProductApi | null>) {
        if (!data.value?.variants || !data.value?.options) {
            return;
        }
        productStore.setEcommerceProduct(data.value);
        productStore.updateSelectedOptions(data.value.selectedVariant.options);
        if (siteStore.configuration.isIframeMode && productStore.ecommerceProduct.variants.length > 0) {
            const variantRefs: string[] = [];
            productStore.ecommerceProduct.variants.forEach((variant) => {
                variantRefs.push(variant.variantRef);
            });
            stageStore.expectedVariantType = 'product';
            const { askVariantsData } = usePostMessage();
            askVariantsData(variantRefs, data.value?.productHandle);
        }
    }

    return {
        processProductData,
        processEcommerceData
    };
}
